import { render } from "./StoryAvatar.vue?vue&type=template&id=2e1ca0ab"
import script from "./StoryAvatar.vue?vue&type=script&lang=js"
export * from "./StoryAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__